import { render } from "./EditPhysician.vue?vue&type=template&id=2886f14f&ts=true"
import script from "./EditPhysician.ts?vue&type=script&lang=ts&external"
export * from "./EditPhysician.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__